var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpsellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "lightblue",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8.36743C2.25 5.1918 4.82436 2.61743 8 2.61743H16C19.1756 2.61743 21.75 5.1918 21.75 8.36743V16.3674C21.75 19.543 19.1756 22.1174 16 22.1174H8C4.82436 22.1174 2.25 19.543 2.25 16.3674V8.36743ZM5.75 8.36743C5.75 7.95322 5.41421 7.61743 5 7.61743C4.58579 7.61743 4.25 7.95322 4.25 8.36743V16.3674C4.25 18.4385 5.92893 20.1174 8 20.1174H17C17.4142 20.1174 17.75 19.7816 17.75 19.3674C17.75 18.9532 17.4142 18.6174 17 18.6174H8C6.75736 18.6174 5.75 17.61 5.75 16.3674V8.36743ZM17.048 10.5575V11.1321C17.048 11.5463 17.3838 11.8821 17.798 11.8821C18.2123 11.8821 18.548 11.5463 18.548 11.1321V8.79137C18.548 8.59246 18.469 8.40169 18.3284 8.26104C18.1877 8.12039 17.997 8.04137 17.798 8.04137H15.4573C15.0431 8.04137 14.7073 8.37716 14.7073 8.79137C14.7073 9.20559 15.0431 9.54137 15.4573 9.54137H15.9346L13.8018 12.4038C13.7009 12.5392 13.4975 12.5377 13.3987 12.4007L12.9956 11.8424C12.3429 10.9382 11.0224 10.867 10.2762 11.6956L7.88379 14.3524C7.60661 14.6602 7.63144 15.1344 7.93924 15.4116C8.24705 15.6888 8.72127 15.664 8.99845 15.3562L11.3909 12.6994C11.4975 12.581 11.6861 12.5912 11.7794 12.7203L12.1824 13.2787C12.8744 14.2373 14.2983 14.2481 15.0047 13.3L17.048 10.5575Z",
    fill: "lightblue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsellIcon);
export default __webpack_public_path__ + "static/media/upsell-icon.28dca812e7e114ae8dc987f1996c752c.svg";
export { ForwardRef as ReactComponent };